import { useEffect } from 'react';
import Avatar from './Avatar';
import MessageBubble from './MessageBubble';
import ChartsLoading from '@/components/loading/ChartsLoading';
import { useLocation } from 'react-router-dom';
export interface ChartsRef {
  refresh: () => void;
}

import { useChatContext } from '@/contexts/ChatContext';

const ChatInterface = () => {
  const { messages, addMessage } = useChatContext();
  const location = useLocation();
  let isFirst = true;
  useEffect(() => {
    if (location.state?.scjdonclusion && location.state?.userQuestion && isFirst) {
      isFirst = false;
      addMessage({ content: location.state.userQuestion, position: 'right' });
      addMessage({ content: location.state.scjdonclusion, position: 'left' });
    }
  }, [location.state]);

  return (
    <div className="mx-auto min-h-full max-w-4xl rounded-lg bg-white p-4">
      {/* AI助手欢迎消息 */}

      {messages.map((message, index) => (
        <div key={`message-${index}`}>
          {message.position === 'left' && (
            <div className="mb-4 flex flex-col gap-3">
              {index === 0 && <Avatar />}
              {message.loading ? (
                <ChartsLoading size="sm" />
              ) : (
                <MessageBubble className="w-full">
                  {message.content
                    ? message.content
                    : '您好，我是您的AI智能投顾助手。我可以帮您分析市场行情、推荐投资产品、制定资产配置方案，以及回答各类投资理财问题。您可以通过底部输入框与我交流。'}
                </MessageBubble>
              )}
            </div>
          )}
          {message.position === 'right' && (
            <div className="mb-4 flex flex-col gap-3">
              <MessageBubble className="w-full" isUser>
                {message.content}
              </MessageBubble>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

ChatInterface.displayName = 'ChatInterface';

export default ChatInterface;
